// Build and parse a self-contained TimeFlash share link.
// All fields are packed into a base64 JSON blob so the receiver's
// browser can preview the schedule without any backend lookup.

const encode = (obj) => {
  try {
    const json = JSON.stringify(obj);
    // URL-safe base64
    const b64 = typeof btoa === "function"
      ? btoa(unescape(encodeURIComponent(json)))
      : Buffer.from(json, "utf-8").toString("base64");
    return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  } catch {
    return "";
  }
};

const decode = (s) => {
  try {
    let b64 = s.replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4) b64 += "=";
    const json = typeof atob === "function"
      ? decodeURIComponent(escape(atob(b64)))
      : Buffer.from(b64, "base64").toString("utf-8");
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const buildShareUrl = (schedule) => {
  const payload = {
    m: schedule.message,
    at: schedule.scheduled_at,
    s: !!schedule.sound_enabled,
    d: schedule.display_mode || "fit",
    r: schedule.reminder_minutes || null,
    rp: schedule.repeat || "none",
    v: 1,
  };
  const token = encode(payload);
  const base = `${window.location.origin}${window.location.pathname}`;
  return `${base}#import=${token}`;
};

export const parseImportHash = () => {
  if (typeof window === "undefined") return null;
  const hash = window.location.hash || "";
  const m = hash.match(/import=([^&]+)/);
  if (!m) return null;
  const data = decode(m[1]);
  if (!data || !data.m || !data.at) return null;
  return {
    message: data.m,
    scheduled_at: data.at,
    sound_enabled: !!data.s,
    display_mode: data.d === "scroll" ? "scroll" : "fit",
    reminder_minutes:
      typeof data.r === "number" && data.r > 0 ? data.r : null,
    repeat: ["daily", "weekly"].includes(data.rp) ? data.rp : "none",
  };
};

export const clearImportHash = () => {
  if (typeof window === "undefined") return;
  if (window.location.hash && window.location.hash.includes("import=")) {
    history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
  }
};

/**
 * Share a schedule via the OS share sheet (mobile) or fall back to
 * copying the link to clipboard (desktop). Returns a label describing
 * what happened so the caller can toast it.
 */
export const shareSchedule = async (schedule) => {
  const url = buildShareUrl(schedule);
  const title = "TimeFlash";
  const text = `Flash alert: ${schedule.message}`;

  // Prefer navigator.share where it will actually offer multiple channels
  if (navigator.share && navigator.canShare?.({ url })) {
    try {
      await navigator.share({ title, text, url });
      return { kind: "shared", url };
    } catch (err) {
      if (err?.name === "AbortError") return { kind: "cancelled", url };
      // fall through to clipboard
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return { kind: "copied", url };
  } catch {
    return { kind: "fallback", url };
  }
};
